import {BaseError} from '../../../../../../../shared/errors/BaseError'
import {GameTypeEnum, UIMMatchmakingController} from './matchmaking_selection/UIMMatchmakingController'
import {ViewPopup} from '../../../../../../shared/scripts/ui_popup/ViewPopup'
import {UIMLandscapeDeprecationWarningPopup} from '../../../../ui_popup/UIMLandscapeDeprecationWarningPopup.ts'
import {UIDeviceController} from '../../../../../../shared/scripts/ui_html/UIDeviceController'

export class UIMHomepageController {
    private errorPopup: ViewPopup

    readonly matchmakingController: UIMMatchmakingController

    constructor() {
        this.matchmakingController = new UIMMatchmakingController()

        this.setGameModeClickActions()
    }

    private setGameModeClickActions() {
        const playVsBotsCard = document.getElementById('m-gamemode-play-vs-bots') as HTMLDivElement
        const classic1v1Card = document.getElementById('m-gamemode-1v1') as HTMLDivElement
        const classic4pCard = document.getElementById('m-gamemode-classic-4p') as HTMLDivElement
        const citiesAndKnightsCard = document.getElementById('m-gamemode-cities-and-knights') as HTMLDivElement

        playVsBotsCard.onclick = () => this.onCardClick(GameTypeEnum.PlayVsBots)

        classic1v1Card.onclick = () => this.onCardClick(GameTypeEnum.Classic1v1)

        classic4pCard.onclick = () => this.onCardClick(GameTypeEnum.Classic4P)

        citiesAndKnightsCard.onclick = () => this.onCardClick(GameTypeEnum.CitiesAndKnights4P)
    }

    private onCardClick(gameType: GameTypeEnum) {
        this.matchmakingController.showSelectionScreen(gameType)
        if(UIDeviceController.isUserOnTabletApp()) return
        new UIMLandscapeDeprecationWarningPopup().show()
    }

    onHomepageHide() {
        this.matchmakingController.closeAll()
    }

    showMatchmakingError(error: BaseError) {
        this.matchmakingController.stopSearching()
        this.errorPopup?.removePopup()
        this.errorPopup = new ViewPopup({key: 'strings:popups.errors.matchmakingError.rankedMode'},
            error.description,
            () => undefined,
            () => undefined,
            true, {
                showXButton: false,
                showXonHeader: true,
            })
        this.errorPopup.show()
    }
}
